import {
  GET_DISCOUNT_TYPES,
  GET_DISCOUNT_TYPES_SUCCESS,
  GET_DISCOUNT_TYPES_FAIL,
  CREATE_DISCOUNT_TYPE,
  CREATE_DISCOUNT_TYPE_SUCCESS,
  CREATE_DISCOUNT_TYPE_FAIL,
  CLEAR_DISCOUNT_TYPE_ERROR,
} from "./actionTypes"

// Get all discount types
export const getDiscountTypes = (history) => ({
  type: GET_DISCOUNT_TYPES,
  payload: { history },
})

// Create new discount type
export const createDiscountType = (discountType, history) => ({
  type: CREATE_DISCOUNT_TYPE,
  payload: { discountType, history },
})

// Clear discount type errors
export const clearDiscountTypeError = () => ({
  type: CLEAR_DISCOUNT_TYPE_ERROR,
})
